interface GeneralError {
    reasons: string[]
    code: string
    params: { [key: string]: any }
}

export interface PartipostApiError {
    general_errors: GeneralError
    validation_errors: any
}

type PartipostErrorCodes =
    | 'CAMPAIGN_INVALID'
    | 'TASK_INVALID'
    | 'SUBMISSION_PROGRESS_SUMMARY_INVALID'
    | 'SUBMISSION_PERFORMANCE_INVALID'
    | 'SUBMISSION_PROGRESS_INVALID'
    | 'SUBMISSION_REJECTED_INVALID'
    | 'SUBMISSION_DROPOUTS'
    | 'LOGIN_INVALID'
    | 'UPDATE_PASSWORD_ERROR'
    | 'REGISTRATION_RESULTS_INVALID'
    | 'REGISTRATION_INVALID'
    | 'SUBMISSION_PERFORMANCE_INVALID'

type PartipostErrorReasons =
    | 'NOT_FOUND'
    | 'NOT_AUTHENTICATED'
    | 'AUTHENTICATION_FAILED'
    | 'USER_IS_NOT_TEAM_MEMBER'
    | 'PARSE_ERROR'
    | 'PERMISSION_DENIED'
    | 'UNKNOWN_ERROR'
    | 'INVALID_CREDENTIALS'
    | 'INVALID_PASSWORD'
    | 'SUBMISSION_NOT_IN_BATCH'
    | 'CAMPAIGN_INCOMPLETE'
    | 'NEXT_STEP_SCHEDULE_OVER'
    | 'SCHEDULE_OVER'
    | 'REGISTRATION_PRIORITY_WAITLISTED_SLOT_INSUFFICIENT'
    | 'REGISTRATION_MAX_SLOTS_LOWER_THAN_USED'
    | 'END_TIME_MUST_BE_N_HOURS_LATER_THAN_PREV_STEP'
    | 'UPDATE_NOT_ALLOWED'
    | 'REGISTRATION_SLOT_INSUFFICIENT'
    | 'SUBMISSION_EARNINGS_ADJUSTMENT_ON_PROCESS'
    | 'SUBMISSION_PAID'
    | 'SUBMISSION_REJECTED'
    | 'EMAIL_ALREADY_IN_USED_FOR_APP'

export const checkForError = (error: PartipostApiError, code: PartipostErrorCodes, reason: PartipostErrorReasons) => {
    if (error === undefined) return false
    const { general_errors: generalErrors } = error
    return generalErrors && generalErrors.code === code && generalErrors.reasons.indexOf(reason) >= 0
}

export const getErrorMessage = (error: PartipostApiError) => {
    if (error === undefined) return false
    const { general_errors: generalErrors } = error
    return generalErrors && generalErrors.params && generalErrors.params.details
}

export const isUnknownError = (error: PartipostApiError) =>
    error.general_errors.reasons && error.general_errors.reasons.indexOf('UNKNOWN_ERROR') >= 0

export const isPermissionDeniedError = (error: PartipostApiError) =>
    error.general_errors.reasons && error.general_errors.reasons.indexOf('PERMISSION_DENIED') >= 0

export const isUserNotInTeamError = (errors: GeneralError) =>
    errors.reasons && errors.reasons?.includes('USER_IS_NOT_TEAM_MEMBER')
